import { getAmountDue } from '../../state/helpers';
import { useGlobalState } from '../../state/state';
import { formatMembershipNumber, getMembershipTitle } from '../../utils/stringHelper';
import { Stack, Typography, Icon } from '@ace-clublabs/shared-component-library';
import { getIsUpgrading, getPendingLevel } from '../Notifications/buildNotifications';

export const MembershipDetails = () => {
  const [membershipDetails] = useGlobalState('memberDetails');
  const [paymentInfo] = useGlobalState('paymentInfo');
  const [priceCart] = useGlobalState('priceCart');

  const {
    membershipNumber,
    benefitLevels,
    termExpirationDate,
    priorTermExpirationDate,
    joinYear,
    products,
    inArrears,
  } = membershipDetails;

  let membershipTitle = getMembershipTitle(membershipDetails, benefitLevels?.existingLevel);
  const isUpgradingBenefitLevel = getIsUpgrading(membershipDetails);

  if (isUpgradingBenefitLevel) {
    const pendingLevelInfo = getPendingLevel(membershipDetails);
    membershipTitle = getMembershipTitle(membershipDetails, pendingLevelInfo?.pendingLevel!);
  }

  const formattedMemberNumber = formatMembershipNumber(membershipNumber);

  const yearsOfLoyalty = getYearsOfLoyalty(joinYear);

  const amountDue = getAmountDue(membershipDetails, paymentInfo?.monthlyPaymentData, priceCart);

  const validThroughDate = inArrears && amountDue > 0 ? priorTermExpirationDate : termExpirationDate;

  return (
    <Stack className="membership-detail-section" sx={{ margin: '24px 0px' }}>
      <Typography
        className="membership-loyalty-message"
        variant="b1Medium"
        sx={{
          fontWeight: '500',
          color: '#0C7A93',
          alignItems: 'center',
        }}
      >
        <Icon iconName="sparkles-duotone" sx={{ fontSize: '1.5rem', marginRight: '0.5rem' }}></Icon>
        {getLoyaltyText(yearsOfLoyalty)}
      </Typography>
      <Typography className="membership-level-title" variant="h3" sx={{ marginBottom: '8px', fontWeight: '700' }}>
        {membershipTitle} member
      </Typography>
      <Typography
        className="membership-level-detail"
        variant="b2Regular"
        sx={{ fontWeight: '400' }}
        data-qm-encrypt="true"
      >
        Membership #: <strong>{formattedMemberNumber}</strong>
      </Typography>
      <Typography className="valid-through-date" variant="b2Regular" sx={{ fontWeight: '400' }}>
        Valid through: <strong>{validThroughDate}</strong>
      </Typography>
    </Stack>
  );
};

function getYearsOfLoyalty(joinYear?: string | null) {
  let currentDate = new Date();
  let thisYear = currentDate.getFullYear();

  // coerce join year into a digit string or an empty string if invalid string characters are present
  if (typeof joinYear === 'string') {
    joinYear = joinYear
      ?.split('')
      .filter((char) => '0123456789'.includes(char))
      .join('');
  }

  const yearsDiff = thisYear - Number(joinYear || thisYear);
  const yearsOfLoyalty = yearsDiff;
  return yearsOfLoyalty;
}

function getLoyaltyText(yearsOfLoyalty: number) {
  if (yearsOfLoyalty < 1) return 'Thanks for being a member';
  else if (yearsOfLoyalty >= 1 && yearsOfLoyalty < 2) return 'Thanks for being a member for 1 year';

  return `Thanks for being a member for ${yearsOfLoyalty} years`;
}
